import { styled } from "@mui/material";
import { middleEllipsisName } from "../classes.js";
const Root = styled("span", {
  name: middleEllipsisName,
  slot: "Root",
  overridesResolver: (_props, styles) => styles.root
})`
  display: flex;
  overflow-wrap: normal;
  white-space: pre;

  .ellipsis {
    /* ATTENTION: to avoid messing with the math computing the ellipsis you should not affect the ellipsis dimensions*/
    margin: 0 !important;
    padding: 0 !important;

    /* Add here default styles applied to the ellipsis. Root.sx could override it. */
  }
`;
export {
  Root
};
//# sourceMappingURL=Root.js.map
